import { convertCelsiusToFahrenheit } from "./common_utils";

export const MAX_SCHEDULE_EVENTS = 28;

export const SCHEDULE_DAYS_ORDER = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

export const SCHEDULE_DAY_LABELS = {
  SUNDAY: "Su",
  MONDAY: "M",
  TUESDAY: "T",
  WEDNESDAY: "W",
  THURSDAY: "Th",
  FRIDAY: "F",
  SATURDAY: "S",
};

export const SCHEDULE_DAY_SHORT_NAMES = {
  SUNDAY: "Sun",
  MONDAY: "Mon",
  TUESDAY: "Tue",
  WEDNESDAY: "Wed",
  THURSDAY: "Thu",
  FRIDAY: "Fri",
  SATURDAY: "Sat",
};

export function minuteOfDayToTimeInputValue(minuteOfDay) {
  const hours = Math.floor(minuteOfDay / 60) % 24;
  const minutes = minuteOfDay % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

export function timeInputValueToMinuteOfDay(timeInputValue) {
  const [hours, minutes] = timeInputValue.split(":").map(Number);
  return hours * 60 + minutes;
}

export function formatMinuteOfDayLabel(minuteOfDay) {
  const hours = Math.floor(minuteOfDay / 60) % 24;
  const minutes = minuteOfDay % 60;
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHours}:${String(minutes).padStart(2, "0")} ${period}`;
}

export function formatEventSummary(event) {
  if (event.eventType === "OFF") {
    return "OFF";
  }

  if (event.eventType === "FAN_ONLY") {
    return `${event.fanSetting} FAN`;
  }

  const heatF =
    event.heatTargetTempC != null ? convertCelsiusToFahrenheit(event.heatTargetTempC) : null;
  const coolF =
    event.coolTargetTempC != null ? convertCelsiusToFahrenheit(event.coolTargetTempC) : null;

  if (event.eventType === "HEAT_AND_COOL") {
    return [heatF, coolF].filter((value) => value != null).map((value) => `${value}°`).join(" ");
  }

  if (event.eventType === "HEAT") {
    return heatF != null ? `${heatF}°` : "--";
  }

  return coolF != null ? `${coolF}°` : "--";
}

// Returns the index of the first event in `events` that recurs on at least one of the same
// `candidateDays` at the same `candidateMinuteOfDay`, or -1 if none conflict. Pass the index of the
// event being edited as `excludeIndex` so it doesn't get flagged as conflicting with itself.
export function findConflictingEventIndex(events, candidateDays, candidateMinuteOfDay, excludeIndex = -1) {
  const candidateDaySet = new Set(candidateDays ?? []);
  for (let index = 0; index < events.length; index += 1) {
    if (index === excludeIndex) {
      continue;
    }
    const event = events[index];
    if (event.minuteOfDay !== candidateMinuteOfDay) {
      continue;
    }
    const overlapsADay = (event.daysOfWeek ?? []).some((day) => candidateDaySet.has(day));
    if (overlapsADay) {
      return index;
    }
  }
  return -1;
}
